import * as React from 'react';
import { compose, pure } from 'recompose';
import { createStyles, withStyles } from '@material-ui/styles';
import Checkbox from '@material-ui/core/Checkbox';
import { Select, SelectItem, Text } from '../../';
import { Field } from 'redux-form';
const styles = (theme) => createStyles({
    control: {
        minWidth: 200,
    },
    item: {
        paddingLeft: 0,
    },
    checkbox: {
        color: theme.color.font.dark,
    },
});
const MultiSelect = (props) => {
    const { classes, name, label, items = [], selectedItems = [], testId = 'MultiSelect', renderValue, ...others } = props;
    const itemList = items.map((item) => (React.createElement(SelectItem, { "data-testid": `${testId}-item-${item.value}`, key: item.value, value: item.value, className: classes.item },
        React.createElement(Checkbox, { "data-testid": `${testId}-item-${item.value}-checkbox`, checked: selectedItems.indexOf(item.value) > -1, className: classes.checkbox }),
        React.createElement(Text, null, item.label))));
    return (React.createElement(Field, Object.assign({ "data-testid": `${testId}`, name: name, multiple: true, label: label, renderValue: renderValue, component: Select, className: classes.control, format: (value) => (Array.isArray(value) ? value : []) }, others), itemList));
};
const ComposedMultiSelect = compose(withStyles(styles, { withTheme: true }), pure)(MultiSelect);
ComposedMultiSelect.displayName = 'MultiSelect';
export default ComposedMultiSelect;
//# sourceMappingURL=MultiSelect.js.map